import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { RespostaWebAPI } from '../Models/resposta-web-api.model';

@Injectable()
export class EnumeradorService {

  private url = `${environment.apiUrl}` + 'enumeradores';
  
  constructor(private http: HttpClient) { }

  get(tipoEnumerador: string): Observable<any[]> {
    const params = new HttpParams().set('tipoEnumerador', tipoEnumerador);
    return this.http.get<RespostaWebAPI>(this.url, { params: params })
      .pipe(map((response: RespostaWebAPI) => response.data));
  }
}
